import { createReducer, on } from '@ngrx/store';
import { MerlinSearchActions } from '@src/suite/common/store/merlin/actions/ai.search.actions';
import { MerlinState } from '@src/suite/common/store/merlin/models/ai.seach.models';

export const initialState: MerlinState = {
    merlinMediaSearch: {
        searchTerm: {
            searchText: '',
            generating: false,
        },
        executing: false,
        photos: [],
        videos: [],
    },
    merlinEntitySearch: {
        executing: false,
        hashtags: [],
        people: [],
        places: [],
    },
};

export const merlinSearchReducer = createReducer(
    initialState,
    on(MerlinSearchActions.clearSearchResults, (): MerlinState => {
        return initialState;
    }),
    on(MerlinSearchActions.generatePhotoAndVideoSearchTerm, (state, _action): MerlinState => {
        return {
            ...state,
            merlinMediaSearch: {
                searchTerm: {
                    ...state?.merlinMediaSearch?.searchTerm,
                    generating: true,
                },
            },
        };
    }),
    on(MerlinSearchActions.photoAndVideoSearchTermGenerated, (state, action): MerlinState => {
        if (action.searchTerm && action.searchTerm !== state.merlinMediaSearch.searchTerm.searchText) {
            return {
                ...state,
                merlinMediaSearch: {
                    searchTerm: {
                        ...state?.merlinMediaSearch?.searchTerm,
                        generating: false,
                    },
                },
            };
        }
        return state;
    }),
    on(MerlinSearchActions.searchPhotoAndVideoSuccess, (state, action): MerlinState => {
        return {
            ...state,
            merlinMediaSearch: {
                ...state?.merlinMediaSearch,
                searchTerm: {
                    searchText: action.searchTerm,
                    generating: false,
                },
                executing: false,
                photos: action.photos,
                videos: action.videos,
            },
        };
    }),
    on(MerlinSearchActions.searchPhotoAndVideoError, (state): MerlinState => {
        return {
            ...state,
            merlinMediaSearch: {
                ...state?.merlinMediaSearch,
                searchTerm: {
                    ...state?.merlinMediaSearch?.searchTerm,
                    generating: false,
                },
                executing: false,
            },
        };
    }),
    on(MerlinSearchActions.searchEntity, (state, _action): MerlinState => {
        return {
            ...state,
            merlinMediaSearch: {
                ...state?.merlinMediaSearch,
            },
            merlinEntitySearch: {
                ...state?.merlinEntitySearch,
                executing: true,
            },
        };
    }),
    on(MerlinSearchActions.searchEntitySuccess, (state, action): MerlinState => {
        return {
            ...state,
            merlinMediaSearch: {
                ...state?.merlinMediaSearch,
            },
            merlinEntitySearch: {
                ...action.searchResults,
                executing: false,
            },
        };
    })
);
